/**
 * Allows a "save as draft" button to set a draft value before submitting
 */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["publishInput"];

  submitAsDraft(e) {
    if (!this.hasPublishInputTarget) {
      console.warn("No publish input provided, cannot post draft!");
      e.preventDefault();
      return;
    }

    this.publishInputTarget.value = false;
  }
}
